import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { UntypedFormGroup, FormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Constant, ManageTitle, ContentTypeValues, SolrContentTypeValues } from 'src/app/common/constant/constant';
import { ApiService } from 'src/app/services/api/api.service';
import { LandingpageService } from 'src/app/services/landingpage/landingpage.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { countries } from 'country-data';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import * as ClassicEditor from "src/build/ckeditor";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MediaUploadComponent } from 'src/app/components/media-upload/media-upload.component';
import * as moment from 'moment';
import { RepairOrderService } from 'src/app/services/repair-order/repair-order.service';
import { BaseService } from 'src/app/modules/base/base.service';
import { Subscription } from "rxjs";
import { CommonService } from 'src/app/services/common/common.service';
import {Stripe, StripeCard, StripeScriptTag} from 'stripe-angular';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-iscan-ro-form',
  templateUrl: './iscan-ro-form.component.html',
  styleUrls: ['./iscan-ro-form.component.scss']
})
export class IscanRoFormComponent implements OnInit {
  @Input() public domainId: any = 0;
  @Input() public workStreamId: any = [];
  @Input() public cardFlag: boolean = false;
  @Input() public endUser: boolean = false;
  @Output() existAction:EventEmitter<any> = new EventEmitter();
  @Output() setupWOId: EventEmitter<any> = new EventEmitter();
  @Output() iscanComponentRef: EventEmitter<IscanRoFormComponent> = new EventEmitter();
  @Output() iscanCallback: EventEmitter<IscanRoFormComponent> = new EventEmitter();
  subscription: Subscription = new Subscription();

  public bodyClass:string = "application-form";
  public bodyClass2: string = "submit-loader";
  public bodyElem;
  public user;
  public userId: any = 4517;
  public workOrderId: any = 0;
  public displayOrder: number = 0;
  public emitAction: string = "init";
  public iscanFormData: any = {};
  public mediaConfig: any = {backdrop: 'static', keyboard: false, centered: true, windowClass: 'attachment-modal'};
  public year = moment().year();
  public Editor = ClassicEditor;
  applicationForm: UntypedFormGroup;
  jobTitleForm: UntypedFormGroup;
  jobTitleFormSubmit: boolean = false;
  public applicationFormValid: boolean = false;
  public applicationFormSubmit: boolean = false;
  public jbtFormProcessing: boolean = false;
  public submitClicked: boolean = false;
  public isSameBusiness: any = 0;
  public disableSameBusiness: boolean = false;
  public checkContactFlag: any = null;
  public businessExist: boolean = false;
  public timeZoneList: any = [{id: 'EST', name: 'EST'},{id: 'CST', name: 'CST'},{id: 'MST', name: 'MST'},{id: 'PST', name: 'PST'}];
  //public jobTitleList: any = [{id: 0, name: 'New'}];
  public jobTitleList: any = [];
  public requestTypeOptions: any = ['Urgent (As soon as possible)', 'Flexible (Make an appointment for future time)', 'Inquiry (SOD coverage / Module customization)'];
  public serviceTypeOptions: any = [{name: 'Advanced Diagnostic Support', checked: false}, {name: 'Health Check (Code checks / Update availability)', checked: false}, {name: 'Coding / Programming', checked: false}, {name: 'ECU Module Recovery / Customized Capability', checked: false}];
  public serviceOptions: any = [{name: 'New Module / Initial Start Up', checked: false}, {name: 'ECU Module Update', checked: false}, {name: 'Retrofit / Conversions / Customization', checked: false}, {name: 'Vehicle Fault Repair Troubleshooting Process', checked: false}];
  public conditionOptions: any = [{name: 'Original', checked: false}, {name: 'New - OE Replacement', checked: false}, {name: 'New - Remanufactured', checked: false}, {name: 'Used - Second Hand Module', checked: false}];
  public communicationOptions: any = [{name: 'YES', checked: false}, {name: 'YES, but it does/didn\'t work', checked: false}, {name: 'NO', checked: false}, {name: 'NOT SURE', checked: false}];
  public prevAttemptOptions: any = [{name: 'YES PA', checked: false}, {name: 'YES, but it does/didn\'t work PA', checked: false}, {name: 'NO PA', checked: false}, {name: 'NOT SURE', checked: false}];
  public insuranceOptions: any = [{id: 'Yes', name: 'Yes'},{id: 'No', name: 'No'}];
  public toolOptions: any = [{id: 0, name: 'Select'}];
  public vehicleConditionOptions: any = [{id:'Communication issues?', name:'Communication issues', checked: false}, {id:'Water Damage?', name:'Water Damage', checked: false}, {id:'Collision Damage?', name:'Collision Damage', checked: false}];
  public selectedJobtitle;
  public threadCategory: any = 1;
  public accountEmail: string = "";
  public phoneNumberData:any;
  public icountryName = '';
  public icountryCode = '';
  public idialCode = '';
  public iphoneNumber = '';
  public phonenoInputFlag:boolean = true;
  public phoneNumberValid:boolean = false;
  public invalidNumber:boolean = true; 
  public contactPhoneNumberData:any;
  public cicountryName = '';
  public cicountryCode = '';
  public cidialCode = '';
  public ciphoneNumber = '';
  public cphonenoInputFlag:boolean = true;
  public cphoneNumberValid:boolean = false;
  public cinvalidNumber:boolean = true; 
  public ecuAdditionalFieldFlag: boolean = false;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom, CountryISO.Australia, CountryISO.India];
  selectedCountryIS0: any = '';
  contactSelectedCountryIS0: any = '';
  phoneValue: any;
  contactPhoneValue: any;
  public customerComplaint: any = "";
  public customerComplaintPlaceHolder: any = "";
  public customerComplaintFlag: boolean = false;
  public repairHistory: any = "";
  public repairHistoryPlaceHolder: any = "";
  public repairHistoryFlag: boolean = false;
  public warningInfo: any = "";
  public warningInfoPlaceHolder: any = "";
  public warningInfoFlag: boolean = false;
  public providerRequest: any = "";
  public providerRequestPlaceHolder: any = "";
  public providerRequestFlag: boolean = false;
  public phoneDisable: boolean = true;
  public makeDisable: boolean = true;
  public modelDisable: boolean = true;
  public yearDisable: boolean = true;
  public vinIsValid:boolean = false;
  public vinValid:boolean = true;
  public vinVerfied:boolean = true;
  public vinDisable:boolean = false;
  public vinLoading:boolean = false;
  public vinData: any = [];
  public terms: any = 0;
  formProcessing: boolean = false;
  public postUploadActionTrue: boolean = false;
  public postUpload: boolean = true;
  public manageAction: string;
  public postApiData: object;
  public uploadedItems: any = [];
  public commentUploadedItemsFlag: boolean = false;
  public commentUploadedItemsLength: number = 0;
  public contentType: number = 50;
  public mediaUploadItems: any = [];
  public mediaAttachments: any = [];
  public mediaAttachmentsIds: any = [];
  public phMax: number = 10;
  public successFlag: boolean = false;
  public jbtExist = true;
  public actionFlag:boolean = false;
  public existError = '';
  public actionTitle = '';
  public actionForm = '';
  public currentTime: string = new Date().toLocaleString();
  public ctime: string = moment(this.currentTime).format('hh:mm A');
  public currDate: any = '';
  public submitText: string = 'Approve and Submit';

  public vinDisplayModal: boolean = false;
  public dialogLoader: boolean = false;
  public dialogClose: boolean = false;
  public dialogEscClose: boolean = false;
  public vinDecode: string = 'Decoding VIN..';
  public dialogContent: string = this.vinDecode;

  public submitModal: boolean = false;
  public submitDialogClose: boolean = false;
  public submitDialogEscClose: boolean = false;
  public submitDialogContent: string = 'Submitting your request..';
  public complaintConfigCke: any;
  public repairOrderHistoryConfigCke: any;
  public warningConfigCke: any;
  public providerRequestConfigCke: any;

  // complaintConfigCke: any = {
  //   placeholder: 'Customers original complaint',
  //   toolbar: {
  //     emoji: [
  //       { name: 'smile', text: '😀' },
  //       { name: 'wink', text: '😉' },
  //       { name: 'cool', text: '😎' },
  //       { name: 'surprise', text: '😮' },
  //       { name: 'confusion', text: '😕' },
  //       { name: 'crying', text: '😢' }
  //   ],
  //     items: [
  //      "bold",
  //       "Emoji",
  //       "italic",
  //       "link",
  //      "strikethrough",
  //       "|",
  //       "fontSize",
  //       "fontFamily",
  //       "fontColor",
  //       "fontBackgroundColor",
  //       "|",
  //       "bulletedList",
  //       "numberedList",
  //       "todoList",
  //       "|",
  //       "uploadImage",
  //       "pageBreak",
  //       "blockQuote",
  //       "insertTable",
  //       "mediaEmbed",
  //       "undo",
  //       "redo",
       
  //     ],
  //   },
  //   link: {
  //     // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
  //     addTargetToExternalLinks: true,
  //   },
  //   mediaEmbed:{ previewsInData: true },
  //   simpleUpload: {
  //     // The URL that the images are uploaded to.
  //     //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
  //     //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
  //     uploadUrl: this.apiUrl.uploadURL,
  //   },
  //   image: {
  //     resizeOptions: [
  //       {
  //         name: "resizeImage:original",
  //         value: null,
  //         icon: "original",
  //       },
  //       {
  //         name: "resizeImage:50",
  //         value: "50",
  //         icon: "medium",
  //       },
  //       {
  //         name: "resizeImage:75",
  //         value: "75",
  //         icon: "large",
  //       },
  //     ],
  //     toolbar: [
  //       "imageStyle:inline",
  //       "imageStyle:block",
  //       "imageStyle:side",
  //       "|",
  //       "resizeImage:50",
  //       "resizeImage:75",
  //       "resizeImage:original",
  //       "|",
  //       "toggleImageCaption",
  //       "imageTextAlternative",
  //     ],
  //   },
  //   table: {
  //     contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
  //   },
  //   // This value must be kept in sync with the language defined in webpack.config.js.
  //   language: "en",
  //   maxLength: 10
  // };

  // repairOrderHistoryConfigCke: any = {
  //   placeholder: 'Repair / Work history details',
  //   toolbar: {
  //     emoji: [
  //       { name: 'smile', text: '😀' },
  //       { name: 'wink', text: '😉' },
  //       { name: 'cool', text: '😎' },
  //       { name: 'surprise', text: '😮' },
  //       { name: 'confusion', text: '😕' },
  //       { name: 'crying', text: '😢' }
  //   ],
  //     items: [
  //      "bold",
  //       "Emoji",
  //       "italic",
  //       "link",
  //      "strikethrough",
  //       "|",
  //       "fontSize",
  //       "fontFamily",
  //       "fontColor",
  //       "fontBackgroundColor",
  //       "|",
  //       "bulletedList",
  //       "numberedList",
  //       "todoList",
  //       "|",
  //       "uploadImage",
  //       "pageBreak",
  //       "blockQuote",
  //       "insertTable",
  //       "mediaEmbed",
  //       "undo",
  //       "redo",
       
  //     ],
  //   },
  //   link: {
  //     // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
  //     addTargetToExternalLinks: true,
  //   },
  //   mediaEmbed:{ previewsInData: true },
  //   simpleUpload: {
  //     // The URL that the images are uploaded to.
  //     //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
  //     //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
  //     uploadUrl: this.apiUrl.uploadURL,
  //   },
  //   image: {
  //     resizeOptions: [
  //       {
  //         name: "resizeImage:original",
  //         value: null,
  //         icon: "original",
  //       },
  //       {
  //         name: "resizeImage:50",
  //         value: "50",
  //         icon: "medium",
  //       },
  //       {
  //         name: "resizeImage:75",
  //         value: "75",
  //         icon: "large",
  //       },
  //     ],
  //     toolbar: [
  //       "imageStyle:inline",
  //       "imageStyle:block",
  //       "imageStyle:side",
  //       "|",
  //       "resizeImage:50",
  //       "resizeImage:75",
  //       "resizeImage:original",
  //       "|",
  //       "toggleImageCaption",
  //       "imageTextAlternative",
  //     ],
  //   },
  //   table: {
  //     contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
  //   },
  //   // This value must be kept in sync with the language defined in webpack.config.js.
  //   language: "en",
  //   maxLength: 10
  // };

  // warningConfigCke: any = {
  //   placeholder: 'Please list any warning lights / messages on',
  //   toolbar: {
  //     emoji: [
  //       { name: 'smile', text: '😀' },
  //       { name: 'wink', text: '😉' },
  //       { name: 'cool', text: '😎' },
  //       { name: 'surprise', text: '😮' },
  //       { name: 'confusion', text: '😕' },
  //       { name: 'crying', text: '😢' }
  //   ],
  //     items: [
  //      "bold",
  //       "Emoji",
  //       "italic",
  //       "link",
  //      "strikethrough",
  //       "|",
  //       "fontSize",
  //       "fontFamily",
  //       "fontColor",
  //       "fontBackgroundColor",
  //       "|",
  //       "bulletedList",
  //       "numberedList",
  //       "todoList",
  //       "|",
  //       "uploadImage",
  //       "pageBreak",
  //       "blockQuote",
  //       "insertTable",
  //       "mediaEmbed",
  //       "undo",
  //       "redo",
       
  //     ],
  //   },
  //   link: {
  //     // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
  //     addTargetToExternalLinks: true,
  //   },
  //   mediaEmbed:{ previewsInData: true },
  //   simpleUpload: {
  //     // The URL that the images are uploaded to.
  //     //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
  //     //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
  //     uploadUrl: this.apiUrl.uploadURL,
  //   },
  //   image: {
  //     resizeOptions: [
  //       {
  //         name: "resizeImage:original",
  //         value: null,
  //         icon: "original",
  //       },
  //       {
  //         name: "resizeImage:50",
  //         value: "50",
  //         icon: "medium",
  //       },
  //       {
  //         name: "resizeImage:75",
  //         value: "75",
  //         icon: "large",
  //       },
  //     ],
  //     toolbar: [
  //       "imageStyle:inline",
  //       "imageStyle:block",
  //       "imageStyle:side",
  //       "|",
  //       "resizeImage:50",
  //       "resizeImage:75",
  //       "resizeImage:original",
  //       "|",
  //       "toggleImageCaption",
  //       "imageTextAlternative",
  //     ],
  //   },
  //   table: {
  //     contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
  //   },
  //   // This value must be kept in sync with the language defined in webpack.config.js.
  //   language: "en",
  //   maxLength: 10
  // };

  // providerRequestConfigCke: any = {
  //   placeholder: 'Preferred provider request',
  //   toolbar: {
  //     emoji: [
  //       { name: 'smile', text: '😀' },
  //       { name: 'wink', text: '😉' },
  //       { name: 'cool', text: '😎' },
  //       { name: 'surprise', text: '😮' },
  //       { name: 'confusion', text: '😕' },
  //       { name: 'crying', text: '😢' }
  //   ],
  //     items: [
  //      "bold",
  //       "Emoji",
  //       "italic",
  //       "link",
  //      "strikethrough",
  //       "|",
  //       "fontSize",
  //       "fontFamily",
  //       "fontColor",
  //       "fontBackgroundColor",
  //       "|",
  //       "bulletedList",
  //       "numberedList",
  //       "todoList",
  //       "|",
  //       "uploadImage",
  //       "pageBreak",
  //       "blockQuote",
  //       "insertTable",
  //       "mediaEmbed",
  //       "undo",
  //       "redo",
       
  //     ],
  //   },
  //   link: {
  //     // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
  //     addTargetToExternalLinks: true,
  //   },
  //   mediaEmbed:{ previewsInData: true },
  //   simpleUpload: {
  //     // The URL that the images are uploaded to.
  //     //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
  //     //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
  //     uploadUrl: this.apiUrl.uploadURL,
  //   },
  //   image: {
  //     resizeOptions: [
  //       {
  //         name: "resizeImage:original",
  //         value: null,
  //         icon: "original",
  //       },
  //       {
  //         name: "resizeImage:50",
  //         value: "50",
  //         icon: "medium",
  //       },
  //       {
  //         name: "resizeImage:75",
  //         value: "75",
  //         icon: "large",
  //       },
  //     ],
  //     toolbar: [
  //       "imageStyle:inline",
  //       "imageStyle:block",
  //       "imageStyle:side",
  //       "|",
  //       "resizeImage:50",
  //       "resizeImage:75",
  //       "resizeImage:original",
  //       "|",
  //       "toggleImageCaption",
  //       "imageTextAlternative",
  //     ],
  //   },
  //   table: {
  //     contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
  //   },
  //   // This value must be kept in sync with the language defined in webpack.config.js.
  //   language: "en",
  //   maxLength: 10
  // };

  public checkNumber: any;
  public bankName: any;
  public paymentMethod: any = 'card';
  public cmodalConfig: any = {backdrop: 'static', keyboard: false, centered: true};
  /** Stripe */
  extraData = {metadata: null};
  cardCaptureReady = 0;
  stripeOptions = {
    disableLink: true,
    hidePostalCode: true,
    style: {
      base: {
        color: "#495057",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      },
      complete: {
        color: "#495057",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      },
      empty: {
        color: "#495057",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      },
      invalid: {
        color: "#eb1c26",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      }
    }
  };
  invalidError: any;
  cardDetailsFilledOut: any;
  stripeError: string = "";
  showCardError: boolean = false;
  cardInitialized: boolean = false;
  cardSubmitted: boolean = false;
  @ViewChild("stripeCard") stripeCard: StripeCard;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiUrl: ApiService,
    private authenticationService: AuthenticationService,
    private LandingpagewidgetsAPI: LandingpageService,
    private modalService: NgbModal,
    private formBuilder: UntypedFormBuilder,
    private repairOrderApi: RepairOrderService,
    private baseSerivce: BaseService,
    private commonApi: CommonService,
    private stripeScriptTag: StripeScriptTag
  ) {
    if (!this.stripeScriptTag.StripeInstance) {
      if (this.domainId == 71) {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_atg);
      } else if (this.domainId == 515) {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_atgtraining);
      } else if (this.domainId == 386) {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_autoshopanswers);
      } else if (this.domainId == 64) {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_autodiagclinic);
      } else if (this.domainId == 395) {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_lmv);
      } else if (this.domainId == 485) {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_codysautodiagnostics);
      } else if (this.domainId == 367) {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public_evtech);
      } else {
        this.stripeScriptTag.setPublishableKey(environment.stripe.public);
      }
    }



    this.complaintConfigCke = {
      placeholder: 'Customers original complaint',
      toolbar: {
        emoji: [
          { name: 'smile', text: '😀' },
          { name: 'wink', text: '😉' },
          { name: 'cool', text: '😎' },
          { name: 'surprise', text: '😮' },
          { name: 'confusion', text: '😕' },
          { name: 'crying', text: '😢' }
      ],
        items: [
         "bold",
          "Emoji",
          "italic",
          "link",
         "strikethrough",
          "|",
          "fontSize",
          "fontFamily",
          "fontColor",
          "fontBackgroundColor",
          "|",
          "bulletedList",
          "numberedList",
          "todoList",
          "|",
          "uploadImage",
          "pageBreak",
          "blockQuote",
          "insertTable",
          "mediaEmbed",
          "undo",
          "redo",
         
        ],
      },
      link: {
        // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
        addTargetToExternalLinks: true,
      },
      mediaEmbed:{ previewsInData: true },
      simpleUpload: {
        // The URL that the images are uploaded to.
        //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
        //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
        uploadUrl: this.apiUrl.uploadURL,
      },
      image: {
        resizeOptions: [
          {
            name: "resizeImage:original",
            value: null,
            icon: "original",
          },
          {
            name: "resizeImage:50",
            value: "50",
            icon: "medium",
          },
          {
            name: "resizeImage:75",
            value: "75",
            icon: "large",
          },
        ],
        toolbar: [
          "imageStyle:inline",
          "imageStyle:block",
          "imageStyle:side",
          "|",
          "resizeImage:50",
          "resizeImage:75",
          "resizeImage:original",
          "|",
          "toggleImageCaption",
          "imageTextAlternative",
        ],
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
      },
      // This value must be kept in sync with the language defined in webpack.config.js.
      language: "en",
      maxLength: 10
    };

    this.repairOrderHistoryConfigCke = {
      placeholder: 'Repair / Work history details',
      toolbar: {
        emoji: [
          { name: 'smile', text: '😀' },
          { name: 'wink', text: '😉' },
          { name: 'cool', text: '😎' },
          { name: 'surprise', text: '😮' },
          { name: 'confusion', text: '😕' },
          { name: 'crying', text: '😢' }
      ],
        items: [
         "bold",
          "Emoji",
          "italic",
          "link",
         "strikethrough",
          "|",
          "fontSize",
          "fontFamily",
          "fontColor",
          "fontBackgroundColor",
          "|",
          "bulletedList",
          "numberedList",
          "todoList",
          "|",
          "uploadImage",
          "pageBreak",
          "blockQuote",
          "insertTable",
          "mediaEmbed",
          "undo",
          "redo",
         
        ],
      },
      link: {
        // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
        addTargetToExternalLinks: true,
      },
      mediaEmbed:{ previewsInData: true },
      simpleUpload: {
        // The URL that the images are uploaded to.
        //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
        //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
        uploadUrl: this.apiUrl.uploadURL,
      },
      image: {
        resizeOptions: [
          {
            name: "resizeImage:original",
            value: null,
            icon: "original",
          },
          {
            name: "resizeImage:50",
            value: "50",
            icon: "medium",
          },
          {
            name: "resizeImage:75",
            value: "75",
            icon: "large",
          },
        ],
        toolbar: [
          "imageStyle:inline",
          "imageStyle:block",
          "imageStyle:side",
          "|",
          "resizeImage:50",
          "resizeImage:75",
          "resizeImage:original",
          "|",
          "toggleImageCaption",
          "imageTextAlternative",
        ],
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
      },
      // This value must be kept in sync with the language defined in webpack.config.js.
      language: "en",
      maxLength: 10
    };
  
    this.warningConfigCke = {
      placeholder: 'Please list any warning lights / messages on',
      toolbar: {
        emoji: [
          { name: 'smile', text: '😀' },
          { name: 'wink', text: '😉' },
          { name: 'cool', text: '😎' },
          { name: 'surprise', text: '😮' },
          { name: 'confusion', text: '😕' },
          { name: 'crying', text: '😢' }
      ],
        items: [
         "bold",
          "Emoji",
          "italic",
          "link",
         "strikethrough",
          "|",
          "fontSize",
          "fontFamily",
          "fontColor",
          "fontBackgroundColor",
          "|",
          "bulletedList",
          "numberedList",
          "todoList",
          "|",
          "uploadImage",
          "pageBreak",
          "blockQuote",
          "insertTable",
          "mediaEmbed",
          "undo",
          "redo",
         
        ],
      },
      link: {
        // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
        addTargetToExternalLinks: true,
      },
      mediaEmbed:{ previewsInData: true },
      simpleUpload: {
        // The URL that the images are uploaded to.
        //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
        //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
        uploadUrl: this.apiUrl.uploadURL,
      },
      image: {
        resizeOptions: [
          {
            name: "resizeImage:original",
            value: null,
            icon: "original",
          },
          {
            name: "resizeImage:50",
            value: "50",
            icon: "medium",
          },
          {
            name: "resizeImage:75",
            value: "75",
            icon: "large",
          },
        ],
        toolbar: [
          "imageStyle:inline",
          "imageStyle:block",
          "imageStyle:side",
          "|",
          "resizeImage:50",
          "resizeImage:75",
          "resizeImage:original",
          "|",
          "toggleImageCaption",
          "imageTextAlternative",
        ],
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
      },
      // This value must be kept in sync with the language defined in webpack.config.js.
      language: "en",
      maxLength: 10
    };
  
    this.providerRequestConfigCke = {
      placeholder: 'Preferred provider request',
      toolbar: {
        emoji: [
          { name: 'smile', text: '😀' },
          { name: 'wink', text: '😉' },
          { name: 'cool', text: '😎' },
          { name: 'surprise', text: '😮' },
          { name: 'confusion', text: '😕' },
          { name: 'crying', text: '😢' }
      ],
        items: [
         "bold",
          "Emoji",
          "italic",
          "link",
         "strikethrough",
          "|",
          "fontSize",
          "fontFamily",
          "fontColor",
          "fontBackgroundColor",
          "|",
          "bulletedList",
          "numberedList",
          "todoList",
          "|",
          "uploadImage",
          "pageBreak",
          "blockQuote",
          "insertTable",
          "mediaEmbed",
          "undo",
          "redo",
         
        ],
      },
      link: {
        // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
        addTargetToExternalLinks: true,
      },
      mediaEmbed:{ previewsInData: true },
      simpleUpload: {
        // The URL that the images are uploaded to.
        //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
        //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
        uploadUrl: this.apiUrl.uploadURL,
      },
      image: {
        resizeOptions: [
          {
            name: "resizeImage:original",
            value: null,
            icon: "original",
          },
          {
            name: "resizeImage:50",
            value: "50",
            icon: "medium",
          },
          {
            name: "resizeImage:75",
            value: "75",
            icon: "large",
          },
        ],
        toolbar: [
          "imageStyle:inline",
          "imageStyle:block",
          "imageStyle:side",
          "|",
          "resizeImage:50",
          "resizeImage:75",
          "resizeImage:original",
          "|",
          "toggleImageCaption",
          "imageTextAlternative",
        ],
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
      },
      // This value must be kept in sync with the language defined in webpack.config.js.
      language: "en",
      maxLength: 10
    };
  }

  // convenience getters for easy access to form fields
  get apf() { return this.applicationForm.controls; }
  get jbtf() { return this.jobTitleForm.controls; }

  ngOnInit(): void {
    this.bodyElem = document.getElementsByTagName('body')[0];
    this.bodyElem.classList.add(this.bodyClass);
    this.currDate = this.commonApi.createDateAsUTC(new Date());
    if(this.endUser) {
      this.user = this.authenticationService.userValue;
      this.submitText = "Next";
    }
    this.getServiceJobTitleList();
    this.getServiceToolList();
    this.setupForm('application');  
    let defaultLanguage = [{"id":"1","name":"English"}];    
    localStorage.setItem('defaultLanguage', JSON.stringify(defaultLanguage));
  }

  setupForm(access) {
    this.resetForm(access);
    switch(access) {
      case 'application':
        let scountryName = '';
        let scountryCode = '';
        let sdialCode = '';
        let phone = '';
        let vinPattern = `^(?=.*[0-9])(?=.*[A-z])[0-9A-z-]{17}$`;
        this.icountryName = '';
        this.icountryCode = '';
        this.idialCode = '';
        this.iphoneNumber = '';
        this.cicountryName = '';
        this.cicountryCode = '';
        this.cidialCode = '';
        this.ciphoneNumber = '';
        let internationalNumber = this.iphoneNumber.split('(').join('');
        internationalNumber = internationalNumber.split(') ').join('-');
        internationalNumber = `${this.idialCode} ${internationalNumber}`;
        let e164Number = internationalNumber.split(' ').join('');
        e164Number = e164Number.split('-').join('');
        this.phoneNumberData = {  
          countryCode: this.icountryCode, 
          phoneNumber: this.iphoneNumber,
          country: this.icountryName, 
          dialCode: this.idialCode,
          access: 'phone'
        }
        let phoneObject: any = {
          number: this.iphoneNumber,
          internationalNumber,
          nationalNumber: this.iphoneNumber,
          countryCode: this.icountryCode,
          dialCode: this.idialCode
        };
        this.contactPhoneNumberData = {  
          countryCode: this.icountryCode, 
          phoneNumber: this.iphoneNumber,
          country: this.icountryName, 
          dialCode: this.idialCode,
          access: 'phone'
        }
        let cphoneObject: any = {
          number: this.ciphoneNumber,
          internationalNumber,
          nationalNumber: this.ciphoneNumber,
          countryCode: this.cicountryCode,
          dialCode: this.cidialCode
        };
        this.phoneValue = phoneObject;
        this.contactPhoneValue = cphoneObject;
        this.applicationForm = this.formBuilder.group({
          emailAddress: ['', [Validators.required, Validators.email, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
          jobTitle: ['', [Validators.required]],
          firstName: ['', [Validators.required]],
          lastName: ['', [Validators.required]],
          iscanSn: ['', [Validators.required]],
          countryName: [scountryName],
          countryCode: [scountryCode],
          dialCode: [sdialCode],
          phone: [phone, [Validators.required]],
          contactCountryName: [scountryName],
          contactCountryCode: [scountryCode],
          contactDialCode: [sdialCode],
          contactPersonPhone: [phone, [Validators.required]],
          //contactPersonEmail: ['', [Validators.required, Validators.email, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
          businessName: ['', [Validators.required]],
          customerId: '',
          orderNumber: '',
          billingEmail: ['', [Validators.email, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
          appointmentTimeZone: this.timeZoneList[0].name,
          srequestType: [this.requestTypeOptions[0], [Validators.required]],
          serviceType: ['', [Validators.required]],
          vin: ['', [Validators.required, Validators.pattern(vinPattern)]],
          make: ['', [Validators.required]],
          model: ['', [Validators.required]],
          year: ['', [Validators.required]],
          serviceRequest: [''],
          replacementModule: [''],
          ecuSystem: [''],
          ecuModule: [''],
          presentCommunicate: [''],
          prevProgrammingAttempt: [''],
          provider: '',
          supportProvider: '',
          vehicleCondition: '',
          dtc: '',
          insurance: '',
          customerComplaint: [this.customerComplaint, [Validators.required]],
          repairHistory: [this.repairHistory, [Validators.required]],
          warningInfo: this.warningInfo,
          providerRequest: this.providerRequest,
          cardHolderName: ['', [Validators.required]],
          terms: ['', [Validators.required]]
        });
        setTimeout(() => {
          if(this.endUser) {
            let emailAddress = this.user.Email;
            let cardHolderName = this.user.Username;
            console.log(emailAddress, cardHolderName)
            this.terms = 1;
            let terms = this.terms;
            let jobTitle = 1;
            this.applicationForm.patchValue({emailAddress, jobTitle, cardHolderName, terms});
            this.checkROContact(emailAddress, 'shop');
          } else {
            setTimeout(() => {
              let cardHolderField = 'cardHolderName';
              let flag = true;
              this.setFormValidation(flag, cardHolderField)
            }, 500);
          }
          this.iscanComponentRef.emit(this);
          this.iscanCallback.emit(this);
        }, 1000);
        break;
    }
    console.log(this.applicationForm)
  }

  resetForm(access) {
    switch(access) {
      case 'application':
        if(this.applicationFormSubmit) {
          this.applicationForm.reset();
          this.applicationFormValid = false;
          this.applicationFormSubmit = false;
        }
        break;
    }        
  }

  onCountryChange(field,event){
    let countryCode = event.iso2.toUpperCase();
    let phoneObject: any = {
      number: '',
      internationalNumber: '',
      nationalNumber: '',
      countryCode,
      dialCode: ''
    };
    switch(field) {
      case 'phone':
        this.phoneValue = phoneObject;  
        this.applicationForm.patchValue({
          phone: ''
        });
        break;
      case 'contactPhone':
        this.contactPhoneValue = phoneObject;  
        this.applicationForm.patchValue({
          contactPersonPhone: ''
        });
        break;  
    }
  }

  phoneNumberChange(field, action = '') {
    switch(field) {
      case 'phone':
        if(this.phoneValue && this.phoneValue.number != '') {
          let countryCode = this.phoneValue.countryCode;
          console.log(countryCode, countries)
          this.applicationForm.patchValue({
            countryCode,
            countryName: countries[countryCode].name,
            dialCode: this.phoneValue.dialCode
          });
          if(action == 'same') {
            this.setupSamePhone('contact','business');
          }
        }
        break;
      case 'contactPhone':
        if(this.contactPhoneValue && this.contactPhoneValue.number != '') {
          let contactCountryCode = this.contactPhoneValue.countryCode;
          console.log(this.contactPhoneValue, contactCountryCode, countries)
          this.applicationForm.patchValue({
            contactCountryCode,
            contactCountryName: countries[contactCountryCode].name,
            contactDialCode: this.contactPhoneValue.dialCode
          });
          if(action == 'same') {
            this.setupSamePhone('business','contact');
          }
        }
        break;
    }
  }

  onCheckboxChange(field, index, event) {
    console.log(field, index, event)
    let checked = event.target.checked;
    let options: any = [];
    let selectedItems: any = [];
    let selection = 'multiple';
    switch (field) {    
      case 'serviceType':
        options = this.serviceTypeOptions;
        break;
      case 'serviceRequest':
        options = this.serviceOptions;
        break;
      case 'replacementModule':
        options = this.conditionOptions;
        break;
      case 'presentCommunicate':
        options = this.communicationOptions;
        selection = 'single';
        break;
      case 'prevProgrammingAttempt':
        options = this.prevAttemptOptions;
        selection = 'single';
        break;
    }
    options[index].checked = checked;
    options.forEach((item, stIndex) => {
      if(index != stIndex) {
        //item.checked = false;
      }
      if(item.checked) {
        selectedItems.push(item.name);
      }
    });
    this.applicationForm.patchValue({field: selectedItems});
    console.log(selectedItems, this.applicationForm)
  }

  setupSamePhone(currentField, existingField) {
    switch(currentField) {
      case 'contact':
        if(existingField == 'business') {
          this.contactPhoneValue = this.phoneValue;
          this.phoneNumberChange('phone', 'same');
        }
        break;
      case 'business':
        if(existingField == 'contact') {
          this.phoneValue = this.contactPhoneValue;
          this.phoneNumberChange('contactPhone', 'same');          
        }
        break;
    }
  }

  onChange(field){
    let fieldVal = this.applicationForm.get(field).value();
    switch(field) {
      case 'customerComplaint':
        this.customerComplaintFlag = (fieldVal.trim() == '') ? true : false;
        break;
      case 'repairHistory':
        this.repairHistoryFlag = (fieldVal.trim() == '') ? true : false;
        break;
      case 'warningInfo':
        this.warningInfoFlag = (fieldVal.trim() == '') ? true : false;
        break;
      case 'providerRequest':
        this.providerRequestFlag = (fieldVal.trim() == '') ? true : false;
        break;  
    }
  }

  vinChanged(action, val= '') {
    let vinData = this.applicationForm.get('vin');
    console.log(vinData.value)
    this.vinIsValid = (val.length == 17) ? true: vinData.valid;
    this.vinLoading = (this,this.vinIsValid) ? true : false;
    this.vinIsValid = true;
    this.vinValid = (val.length == 17 && vinData.value == '') ? true : false;
    val = val.toUpperCase();
    this.vinVerfied = false;
    this.dialogClose = false;
    this.dialogEscClose = false;
    this.dialogLoader = true;
    this.vinDisplayModal = true;
    let svcFormData = new FormData();
    svcFormData.set('apiKey', Constant.ApiKey);
    svcFormData.set('countryId', '');
    svcFormData.set('domainId', this.domainId);
    svcFormData.set('userId', this.userId);
    svcFormData.set('vin', vinData.value);
    this.LandingpagewidgetsAPI.vehicleInfoByVIN(svcFormData).subscribe(
      (response) => {
        this.dialogClose = true;
        this.dialogEscClose = true;
        this.dialogLoader = false;
        this.vinDisplayModal = false;
        this.vinValid = (response.status == 'Success') ? true : false;
        this.vinLoading = false;
        if (this.vinValid) {
          this.vinDisable = true;
          this.vinVerfied = true;
          this.makeDisable = true;
          this.modelDisable = true;
          this.yearDisable = true;
          //this.applicationForm.patchValue({vin: response.vinNo});
          this.vinData = {
            make: response?.vinDetails[0]?.make,
            model: response?.vinDetails[0]?.model,
            year: response?.vinDetails[0]?.year,
          };
          this.setVINValues('vin');
        }
      }
    );
  }

  setVINValues(access) {
    this.applicationForm.patchValue({
      make: this.vinData?.make,
      model: this.vinData?.model,
      year: this.vinData?.year,
    });
  }


  attachments(items) {
    this.uploadedItems = items;
  }
  attachmentPopup(val = 0,type) {
    let postId = val;
    if(type=='new'){
      postId = 0;
    }
    //(this.uploadedItems); 
    let fitem = [];  
    let mitem = [];  
    let obj = {};
    this.postApiData = {
      action: 'new',
      access: 'workorder',
      pageAccess: 'workorder',
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      countryId: '',
      userId: this.userId,
      threadId: '',      
      postId: postId,      
      contentType: this.contentType,      
      displayOrder: this.displayOrder,
      uploadedItems: [],
      attachments: [],
      attachmentItems: [],
      updatedAttachments: [],
      deletedFileIds: [],
      removeFileIds: [],
      pushData: obj
    };

    if(this.uploadedItems != '') {            
      if(this.uploadedItems.items.length>0){
        fitem = this.uploadedItems; 
        this.postApiData['uploadedItems'] = this.uploadedItems.items;
        this.postApiData['attachments'] = this.uploadedItems.attachments;
      }
    }           
    const modalRef = this.modalService.open(MediaUploadComponent, this.mediaConfig);
    modalRef.componentInstance.access = 'post';
    modalRef.componentInstance.fileAttachmentEnable = true;
    modalRef.componentInstance.mediaAttachments = true;
    modalRef.componentInstance.apiData = this.postApiData;
    modalRef.componentInstance.uploadedItems = fitem;
    modalRef.componentInstance.presetAttchmentItems = mitem;
    modalRef.componentInstance.uploadAttachmentAction.subscribe((receivedService) => {
      //(receivedService.uploadedItems);     
      if(receivedService){
        this.uploadedItems = receivedService.uploadedItems;       
          if(this.uploadedItems != '') {            
            if(this.uploadedItems.items.length>0){
              this.commentUploadedItemsLength = this.uploadedItems.items.length;
              this.commentUploadedItemsFlag = true;              
            }
            else{
              this.commentUploadedItemsLength = 0;
              this.commentUploadedItemsFlag = false;              
            }
          }
          else{
            this.commentUploadedItemsLength = 0;
            this.commentUploadedItemsFlag = false;            
          }         
      }
      else{        
          if(this.uploadedItems.items.length>0){
            this.commentUploadedItemsLength = this.uploadedItems.items.length;
            this.commentUploadedItemsFlag = true;            
          }
          else{
            this.commentUploadedItemsLength = 0;
            this.commentUploadedItemsFlag = false;            
          }
        }      
     // this.apiUrl.attachmentNewPOPUP = false;
      modalRef.dismiss('Cross click');
      
    });      
  }

  getServiceJobTitleList() {
    const searchText = '';
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('userId', this.userId);
    this.LandingpagewidgetsAPI.getServiceJobTitleList(apiFormData).subscribe(
      (response) => {
        console.log(response)
        let jobTitleList = response?.data;
        jobTitleList.forEach(job => {
          this.jobTitleList.push({id: job.id, name: job.jobTitle});
        });
      }
    );
  }

  getServiceToolList() {
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    this.LandingpagewidgetsAPI.getServiceToolList(apiFormData).subscribe(
      (response) => {
        console.log(response)
        let toolList = response?.data;
        toolList.forEach(item => {
          this.toolOptions.push({id: item.id, name: item.name});
        });
      }
    );
  }

  submitcard() {
    this.cardSubmitted = true;
    this.stripeCard.createToken();
  }

  saveService() {
    console.log(this.applicationForm);
    console.log(this.customerComplaint);
    console.log(this.repairHistory);
    console.log(this.warningInfo);
    console.log(this.providerRequest);
    if(this.vinLoading || this.applicationFormValid) {
      return;
    } 
    this.applicationFormSubmit = true;
    console.log(this.vinValid, this.vinVerfied);
    let formObj = this.applicationForm.value;
    let vinValid = (formObj.vin.length == 0 || (this.vinVerfied && this.vinValid)) ? true : false;    
    console.log(vinValid, formObj.vin.length, this.vinVerfied, this.vinValid, formObj);

    let customerComplaintVal = this.applicationForm.value.customerComplaint;
    this.customerComplaintFlag = (customerComplaintVal.trim() == '') ? true : false;
    let repairHistoryVal = this.applicationForm.value.repairHistory;
    this.repairHistoryFlag = (repairHistoryVal.trim() == '') ? true : false;

    console.log(this.applicationForm.valid, vinValid, this.customerComplaintFlag, this.repairHistoryFlag)
    
    if (this.applicationForm.valid && vinValid && !this.customerComplaintFlag && !this.repairHistoryFlag) {
      console.log(this.applicationForm.value.phone);
      console.log(this.applicationForm.value.contactPersonPhone.number);
      if(!this.endUser) {
        this.submitcard();
      } else {
        this.submitService();        
      }      
    }
  }

  fieldChange(event) {
    console.log(event)
    let value = event.value;
    let selectedJobtitle = this.jobTitleList.filter(
      (element) => element.id == value
    );
    console.log(selectedJobtitle)
    this.selectedJobtitle = selectedJobtitle[0];
    //this.applicationForm.patchValue({jobTitle: value});
  }
  
  changeItem(field, event) {
    console.log(event.value)
    switch(field) {
      case 'tool':
        break;
    }
  }

  serviceAction(action, field) {
    this.submitClicked = false;
    this.jbtFormProcessing = false;
    let formTimeout = (action == 'new') ? 0 : 500;
    switch (field) {
      case 'jobTitle':
        let title = 'Job Title'
        this.actionTitle = (action == 'new') ? `${ManageTitle.actionNew} ${title}` : `${ManageTitle.actionEdit} ${title}`;
        this.createForm(field);
        setTimeout(() => {
          this.jbtExist = false;
          this.actionFlag = true;
          this.actionForm = field;  
        }, formTimeout);
        break;
    }
  }

  createForm(action, item:any = '', date:any = '') {
    switch (action) {
      case 'jobTitle':
        let jbtId = (item == '') ? 0 : item.id;
        let jbtName = (item == '') ?  '' : item.name;
        this.jobTitleForm = this.formBuilder.group({
          jbtId,
          jobTitle: [jbtName, [Validators .required]]
        });
      break;
    }
  }

  // Form Action
  formAction(action) {
    console.log(action);
    switch (action) {
      case 'submit':
        this.submitClicked = true;
        this.formSubmit();
        break;

      default:
        this.formProcessing = false;
        this.formCancel();
        break;
    }
  }

  // Form Submit
  formSubmit() {
    const apiInfo = {
      apikey: Constant.ApiKey,
      domainId: this.domainId,
      userId: this.userId,
      action: 'new',
    };
    console.log(this.actionForm)
    switch (this.actionForm) {
      case 'jobTitle':
        this.jbtExist = false;
        this.jobTitleFormSubmit = true;
        for (const i in this.jobTitleForm.controls) {
          this.jobTitleForm.controls[i].markAsDirty();
          this.jobTitleForm.controls[i].updateValueAndValidity();
        }
        const formObj = this.jobTitleForm.value;
        console.log(this.jbtExist, formObj)
        if (this.jobTitleForm.valid && !this.jbtExist) {
          this.formProcessing = true;
          let catgAction = (formObj.catgId == 0) ? apiInfo.action : 'edit';
          apiInfo.action = catgAction;
          apiInfo['catgName'] = formObj.catgName;
          apiInfo['catgId'] = formObj.catgId;
          this.LandingpagewidgetsAPI.manageServiceJobTitleList(apiInfo).subscribe((response) => {
            console.log(response);
            this.jbtFormProcessing = false;
            let error = response.error;
            if(!error) {
              this.actionTitle = '';
              this.jobTitleFormSubmit = false;
              let jbtData = response.data;
              let jbtId = jbtData.id;
              let formJobTitle: any = this.jobTitleForm.get('serviceCatg');
              formJobTitle = (formJobTitle.value == null) ? [] : formJobTitle.value;
              if(catgAction == 'new') {
                this.jobTitleList.push(jbtId);              
                this.applicationForm.patchValue({jobTitle: jbtId});
              } else {
                
              }
              console.log(this.applicationForm);
              this.actionFlag = false;
              this.jbtExist = false;
              this.existError = '';
              this.actionForm = '';
              this.jobTitleForm.reset();
            } else {
              this.jbtExist = true;
              this.existError = response.message;
            }
          });
        } else {
          this.jbtFormProcessing = false;
        }
        break;
    }
  }

  // Form Cancel
  formCancel() {
    this.actionFlag = false;
    this.submitClicked = false;
    switch (this.actionForm) {
      case 'jobTtile':
        this.jbtExist = false;
        this.jobTitleFormSubmit = false;
        this.existError = '';
        break;
    }
  }

  changeField(field, value) {
    console.log(field, value)
    switch(field) {
      case 'accountEmail':
        this.accountEmail = value; 
        break;
    }
  }

  redirectionURL(){
    window.location.reload(); 
  }

  onStripeInvalid(error: any) {
    this.stripeError = error?.message ? error?.message : "";
  }

  onStripeError(error: any) {
    console.error('Stripe error', error);
  }

  onStripeChanged(error: any) {
    if(!this.cardInitialized) this.cardInitialized = true;
    else this.showCardError = true;
  }

  setStripeToken(token: any) {
    console.log(token)
    console.log(this.showCardError, this.cardDetailsFilledOut, this.stripeError)
    this.submitService(token.id);
  }

  setStripeSource(source: any) {
    console.log('Stripe Source', source);
  }

  setStripePaymentMethod(token: any) {
    console.log('Stripe Payment Method', token);
  }

  submitService(token = '') {
    this.applicationFormValid = true;
    this.cardSubmitted = true;
    let uploadCount = 0;
    if(Object.keys(this.uploadedItems).length > 0 && this.uploadedItems.attachments.length > 0) {
      this.uploadedItems.attachments.forEach(item => {
        //console.log(item)
        if(item.accessType == 'media') {
          
        } else {
          uploadCount++;
        }       
      });
    }    
    this.bodyElem.classList.add(this.bodyClass2);
    if(!this.endUser) {
      this.submitModal = true;
    } 
    let appointmentDate = moment(this.currDate).format('YYYY-MM-DD');
    let formControl = this.applicationForm.controls;
    let serviceFormData = new FormData(); 
    let customerComplaint = '';
    let complaintDesc = '';
    let internalNotes = '';
    serviceFormData.append('apiKey', Constant.ApiKey);
    serviceFormData.append('domainId', this.domainId);
    serviceFormData.append('userId', this.userId);
    serviceFormData.append('fromPublic', '1');
    serviceFormData.set('iscanPublic', '1');
    serviceFormData.append('address1', '');
    serviceFormData.append('address2', '');
    serviceFormData.append('city', '');
    serviceFormData.append('state', '');
    serviceFormData.append('zip', '');
    serviceFormData.append('appointmentDate', appointmentDate);
    serviceFormData.append('appointmentTime', this.ctime);
    serviceFormData.append('durationHours', '1 Hour');
    serviceFormData.append('requestType', 'Remote');
    serviceFormData.append('requestTypeId', '1');
    serviceFormData.append('conuntryName', this.phoneNumberData.country);
    serviceFormData.append('conuntryCode', this.phoneNumberData.countryCode);
    serviceFormData.append('dialCode', this.phoneNumberData.dialCode);
    serviceFormData.append('contactPersonEmail', this.applicationForm.value.emailAddress); 
    serviceFormData.append('cardHolderName', this.applicationForm.value.cardHolderName);
    serviceFormData.append('token', token);
    serviceFormData.append('isPreApproved', '1');
    serviceFormData.append('paymentMethod', '1');
    if(!this.endUser) {
      let wsId = this.workStreamId.toString();
      let wsList: any = [wsId];
      serviceFormData.append('worksteamId', JSON.stringify(wsList));
    }
    let threadCategory:any = [];
    threadCategory.push(this.threadCategory.toLocaleString());
    threadCategory.push(this.threadCategory.toLocaleString());
    serviceFormData.append('threadCategory', JSON.stringify(threadCategory));
    formControl['terms'].reset();
    Object.keys(formControl).forEach((key) => {
      console.log(key, formControl[key].value)
      let value = formControl[key].value;
      switch(key) {
        case 'phone':
          serviceFormData.append('phoneNumber', value.number);
          break;
        case 'contactPersonPhone':  
          serviceFormData.append(key, value.number);
          break;
        case 'srequestType':
          if(value == 'Urgent (As soon as possible)') {
            serviceFormData.append('isAsap', '1');
          } else {
            serviceFormData.append('isFlexible', '1');
          }
          complaintDesc = `${complaintDesc}<br><h5>SOD Request Guideline</h5> <p>Support Request Type: ${value}</p>`;
          break;
        case 'serviceType':
          if(value) {
            let stArr = [];
            this.serviceTypeOptions.forEach(st => {
              if(st.checked) {
                stArr.push(st.name);
              }
            });
            console.log(this.serviceTypeOptions, stArr)
            if(stArr.length > 0) {
              complaintDesc = `${complaintDesc} <p>Support Service Type: ${stArr.join(", ")} <p>`;
            }
          }
          break;            
        case 'serviceRequest':
          if(value) {
            let sArr = [];
            this.serviceOptions.forEach(s => {
              if(s.checked) {
                sArr.push(s.name);
              }
            });
            if(sArr.length > 0) {
              complaintDesc = `${complaintDesc}<br><h5>Coding / Programming Request</h5><p>Service Request: ${sArr.join(", ")} <p>`;
            }
          }
          break;  
        case 'replacementModule':
          if(value) {
            let cArr = [];
            this.conditionOptions.forEach(co => {
              if(co.checked) {
                cArr.push(co.name);
              }
            });
            if(cArr.length > 0) {
              complaintDesc = `${complaintDesc}<p>New Replacement Module Detail: ${cArr.join(", ")} <p>`;
            }
          }
          break;
        case 'ecuSystem':
          if(value && value != "") {
            complaintDesc = `${complaintDesc}<br><h5>Control Unit Description</h5><p>ECU SYSTEM: ${value}</p>`;
          }
          break;
        case 'ecuModule':
          if(value && value != "") {
            complaintDesc = `${complaintDesc}<p>ECU Module: ${value}</p>`;
          }
          break;
        case 'presentCommunicate':
          if(value && value != "") {
            complaintDesc = `${complaintDesc}<br><h5>Original ECU Module</h5><p>Still Present & Communicates: ${value}</p>`;
          }
          break;
        case 'prevProgrammingAttempt':
          if(value && value != "") {
            complaintDesc = `${complaintDesc}<p>Any Previous Programming Attempt Made: ${value}</p>`;
          }
          break;
        case 'provider':
          if(this.ecuAdditionalFieldFlag && value && value != "") {
            complaintDesc = `${complaintDesc}<p>Tool and or Provider was used for this Programming Event: ${value}</p>`;
          }
          break;
        case 'supportProvider:':
          if(this.ecuAdditionalFieldFlag && value && value != "") {
            complaintDesc = `${complaintDesc}<p>Preferred support provider you'd like to work with?: ${value}</p>`;
          }
          break;
        case 'vehicleCondition':
          if(this.ecuAdditionalFieldFlag && value && value != "") {
            complaintDesc = `${complaintDesc}<p>Vehicle Condition: ${value}</p>`;
          }
          break;    
        case 'customerComplaint':
          customerComplaint = (this.customerComplaint != '') ? this.customerComplaint : customerComplaint;
          break;
        case 'dtc':
          if(value && value != "") {
            complaintDesc = `${complaintDesc}<p>DTC fault code: ${value}</p>`;
          }
          break;
        case 'insurance':
          if(value && value != "") {
            complaintDesc = `${complaintDesc}<p>Insurance Document Requested: ${value}</p>`;
          }
          break;
        case 'repairHistory':
          internalNotes = (this.repairHistory != '') ? this.repairHistory : internalNotes;
          break;
        case 'warningInfo':
          if(this.warningInfo != '') {
            internalNotes =  `${internalNotes} ${this.warningInfo}`;
          }
          break;
        case 'providerRequest':
          if(this.providerRequest != '') {
            internalNotes = `${internalNotes}<p>Insurance Document Requested: ${this.providerRequest}</p>`;
          }
          break;  
        default:
          serviceFormData.append(key, value);
          break;
      }
    });
    customerComplaint = `${customerComplaint} ${complaintDesc}`;
    serviceFormData.append('description', customerComplaint);
    serviceFormData.append('internalNotes', internalNotes);
    serviceFormData.forEach((value,key) => {
      console.log(key+":"+value)
      this.iscanFormData[key] = value;
      return false
    });

    if(this.endUser) {
      this.emitAction = "submit";
      console.log(this.iscanFormData);
      this.iscanCallback.emit(this);
      return false;
    }

    //return false;

    let pushFormData = new FormData();
    pushFormData.append('apiKey', Constant.ApiKey);
    pushFormData.append('domainId', this.domainId);    
    pushFormData.append('userId', this.userId);
    pushFormData.append('contentTypeId', ContentTypeValues.RepairOrder);
    pushFormData.append('groups', '');                
    pushFormData.append('formWorkOrder', '1');

    this.repairOrderApi.updateSupportTicketsList(serviceFormData).subscribe(res => {
      //console.log(res)
      this.submitModal = false;
      this.bodyElem.classList.remove(this.bodyClass2);
      if(res.status=='Success'){
        let resData = res.data;
        this.formProcessing = false;
        this.applicationFormSubmit = false;
        this.applicationFormValid = false;
        let workOrderId = resData.workOrderId;
        this.workOrderId = workOrderId;
        let postId = workOrderId;
        let threadId = workOrderId;
        this.userId = resData.userId;
        this.setupWOId.emit(workOrderId);
        pushFormData.append('userId', this.userId);
        pushFormData.append('threadId', threadId);
        pushFormData.append('postId', postId);  
        pushFormData.append('workOrderId', workOrderId); 
        if(Object.keys(this.uploadedItems).length > 0 && this.uploadedItems.items.length > 0 && uploadCount > 0) {
          this.postApiData['uploadedItems'] = this.uploadedItems.items;
          this.postApiData['attachments'] = this.uploadedItems.attachments;            
          this.postApiData['message'] = res.result;
          this.postApiData['userId'] = this.userId,
          this.postApiData['workOrderId'] = workOrderId;
          this.postApiData['dataId'] = postId;
          this.postApiData['postId'] = postId;
          this.postApiData['threadId'] = threadId;  
          this.postApiData['pushData'] = pushFormData;                
          this.manageAction = 'uploading';
          this.postUpload = false;             
          setTimeout(() => {   
            this.postUploadActionTrue = true; 
            this.postUpload = true;              
          }, 100);    
        } else {
          let apiDatasocial = new FormData();
          apiDatasocial.append('apiKey', Constant.ApiKey);
          apiDatasocial.append('domainId', this.domainId);
          apiDatasocial.append('workOrderId', workOrderId);
          apiDatasocial.append('userId', this.userId);
          apiDatasocial.append('action', 'create');             
          apiDatasocial.append('actionType', '7');
          this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { });
          this.successFlag = true;
        }
        setTimeout(() => {
          let taction = 'create';
          let tactionType = SolrContentTypeValues.Thread;
          let resPostId = resData.postId;
          let resThreadId = resData.threadId;
          let teamId = (resData.teamId) ? resData.teamId : 0;
          this.updateSolr(taction, tactionType, resThreadId, resPostId);
        }, 500);
      } else{
        this.formProcessing = false;
      }
    },
    (error => {
      //this.errroMsgFlag = true;   
      this.formProcessing = false;  
    }) 
    );
  }

  updateSolr(action, actionType, dataId, postId) {
    let apiDatasocial = new FormData();
    apiDatasocial.append('apiKey', Constant.ApiKey);
    apiDatasocial.append('domainId', this.domainId);
    apiDatasocial.append('userId', this.userId);
    apiDatasocial.append('action', action);
    apiDatasocial.append('actionType', actionType);
    switch (actionType) {
      case 1:
        apiDatasocial.append('threadId', dataId);
        apiDatasocial.append('postId', postId);    
        break;
    }
    this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { });
  }

  checkChange(i) {
    console.log(i)
    this.ecuAdditionalFieldFlag = (i > 1) ? false : true;
  }

  onEmailChange(value) {
    if(!this.apf.emailAddress.errors) {
      this.checkROContact(value, 'shop');      
    }
  }

  // Check RO Contact Exists
  checkROContact(val, access) {
    let roContactData = new FormData();
    roContactData.append('apikey', Constant.ApiKey);
    roContactData.append('domainId', this.domainId);
    roContactData.append('email', val);
    roContactData.append('access', access);
    
    if(this.checkContactFlag){
      this.checkContactFlag.unsubscribe();
      this.fetchContactData(roContactData);
    } else {
      this.fetchContactData(roContactData);      
    }
  }

  fetchContactData(apiData) {
    this.checkContactFlag = this.LandingpagewidgetsAPI.checkROContactExists(apiData).subscribe((response) => {
      let responseData = response.data;
      let resultData = responseData.items;
      this.businessExist = responseData.exist;
      if(!this.endUser && this.businessExist) {
        let email = resultData.shopData.email;
        this.existAction.emit(email);
        return false;
      }
      if(resultData.shopData) {
        let shopData = resultData.shopData;
        let businessName = shopData.name;
        let address1 = shopData.addressLine1;
        let address2 = shopData.addressLine2;
        let city = shopData.city;
        let state = shopData.state;
        let zip = shopData.zip;
        let emailAddress = shopData.email;
        this.applicationForm.patchValue({emailAddress, businessName, address1, address2, city, state, zip});
        this.iphoneNumber = shopData.phone;
        this.idialCode = shopData.dialCode;
        this.icountryCode = shopData.countryCode;
        this.icountryName = shopData.countryName;
        let internationalNumber = this.iphoneNumber.split('(').join('');
        internationalNumber = internationalNumber.split(') ').join('-');
        internationalNumber = `${this.idialCode} ${internationalNumber}`;
        let e164Number = internationalNumber.split(' ').join('');
        e164Number = e164Number.split('-').join('');
        let phoneObject: any = {
          number: this.iphoneNumber,
          internationalNumber,
          nationalNumber: this.iphoneNumber,
          countryCode: this.icountryCode,
          dialCode: this.idialCode
        };
        this.phoneValue = phoneObject;
        this.phoneNumberChange('phone', 'auto');
      }

      if(resultData.contactData && resultData.contactData.length > 0) {
        let contactData = resultData.contactData[0];
        console.log(contactData)
        let firstName = contactData.firstName;
        let lastName = contactData.lastName;
        let email = contactData.email;
        let contactPersonEmail = email;
        this.applicationForm.patchValue({firstName, lastName, contactPersonEmail});
        this.ciphoneNumber = contactData.phoneNumber;
        this.cidialCode = contactData.dialCode;
        this.cicountryCode = contactData.countryCode;
        this.cicountryName = contactData.countryName;
        let internationalNumber = this.ciphoneNumber.split('(').join('');
        internationalNumber = internationalNumber.split(') ').join('-');
        internationalNumber = `${this.cidialCode} ${internationalNumber}`;
        let ce164Number = internationalNumber.split(' ').join('');
        ce164Number = ce164Number.split('-').join('');
        let cphoneObject: any = {
          number: this.ciphoneNumber,
          internationalNumber,
          nationalNumber: this.iphoneNumber,
          countryCode: this.icountryCode,
          dialCode: this.idialCode
        };
        this.contactPhoneValue = cphoneObject;
        this.phoneNumberChange('contactPhone', 'auto');
      } else {
        this.setupSamePhone('contact','business');
      }
    });
  }

  // Set Form Validation
  setFormValidation(flag, field) {
    if(flag) {
      //this.applicationForm.controls[field].setValidators([Validators.required]);
      this.applicationForm.get(field).setValidators([Validators.required]);
      this.applicationForm.updateValueAndValidity(); 
      console.log(this.applicationForm.controls[field])
    }
  }

}
